import React from 'react';
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import withTrans from '../i18n/withTranslation';


const AboutPage = ({ data, t }) => {

  const getContent = (translation) => {
    return { __html: `${t(translation)}` }
  }

  return (
    <>
      <Layout
        title={t('site.pages.AboutPage.meta.title')}
        description={t('site.pages.AboutPage.meta.description')}
        img={data.header.publicURL}
      >
        <Hero
          isDark={true}
          title={t('site.pages.AboutPage.title')}
          subtitle={t('site.pages.AboutPage.subtitle')}
          alt={t('site.pages.AboutPage.headerAlt')}
          img={data.header.publicURL}
        />

        <div className="container my-5">
          <div dangerouslySetInnerHTML={getContent('site.pages.AboutPage.content')}></div>
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  query AboutPage {
    header: file(relativePath: {eq: "about-hero.jpg"}) {
      publicURL
    }
  }
`;

export default withTrans(AboutPage);